import { render, staticRenderFns } from "./comment2.vue?vue&type=template&id=421d4f40&scoped=true&"
import script from "./comment2.vue?vue&type=script&lang=js&"
export * from "./comment2.vue?vue&type=script&lang=js&"
import style0 from "./comment2.vue?vue&type=style&index=0&id=421d4f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d4f40",
  null
  
)

export default component.exports